var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "dropdown",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            _vm.showDateModal = true
          }
        }
      },
      [
        _c("div", [_vm._v(_vm._s(_vm.dateText))]),
        _c("i", { staticClass: "ml-2 icn icn-chevron-down sm" })
      ]
    ),
    _vm.showDateModal
      ? _c("div", { staticClass: "modal overflow-auto" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "header" }, [
              _c("div", { staticClass: "title" }, [
                _c(
                  "div",
                  { staticClass: "flex flex-row space-x-6" },
                  _vm._l(_vm.presetDates, function(item, key, index) {
                    return _c("div", { key: index }, [
                      _c(
                        "button",
                        {
                          class: _vm.matchDate(item)
                            ? "date-selection selected"
                            : "date-selection",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.setDateRange(item)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(key) + " ")]
                      )
                    ])
                  }),
                  0
                )
              ]),
              _c(
                "div",
                {
                  staticClass: "close",
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("i", { staticClass: "icn icn-x sm" })]
              )
            ]),
            _c("div", { staticClass: "content pt-6" }, [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col justify-center items-center h-full mt-4"
                },
                [
                  _c("v-date-picker", {
                    ref: "calendar",
                    attrs: {
                      color: "green",
                      columns: 2,
                      "is-range": "",
                      "max-date": _vm.maxDate
                    },
                    model: {
                      value: _vm.tempRange,
                      callback: function($$v) {
                        _vm.tempRange = $$v
                      },
                      expression: "tempRange"
                    }
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "flex flex-row justify-center items-center mb-6" },
              [
                _c(
                  "button",
                  {
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.confirmedDate()
                      }
                    }
                  },
                  [_vm._v("Confirm")]
                )
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex flex-row bg-primary-100 items-center rounded" },
      [
        _c(
          "div",
          {
            staticClass:
              "flex items-center mr-2 bg-primary-500 py-2 px-2 rounded-l text-white"
          },
          [_c("i", { staticClass: "icn icn-information-circle" })]
        ),
        _c("div", { staticClass: "py-2 pr-2 text-primary-600" }, [
          _vm._v("Double click on a date to choose a single date")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }